import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';
import { finalize, take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-password-recovery',
    templateUrl: './password-recovery.component.html',
    styleUrls: ['./password-recovery.component.scss'],
    standalone: false
})
export class PasswordRecoveryComponent implements OnInit {
  recoveryForm: FormGroup;
  pending = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private authService: AuthService,
    private translate: TranslateService
  ) {
    this.recoveryForm = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', [Validators.required, this.passwordMatchesValidator()]],
      }
    );
  }

  ngOnInit(): void {}

  passwordMatchesValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control.parent?.get('password')?.value;
      const confirmPassword = control.value;

      return password === confirmPassword ? null : {passwordMismatch: {value: control.value}};
    };
  }

  submit(): void {
    if (this.recoveryForm.invalid) {
      this.toastr.error(this.translate.instant('FORM_INVALID'));
      return;
    }

    const password = this.recoveryForm.get('password')?.value;
    const confirmPassword = this.recoveryForm.get('confirmPassword')?.value;

    if (password !== confirmPassword) {
      this.toastr.error(this.translate.instant('PASSWORDS_DO_NOT_MATCH'));
      return;
    }

    const token = this.route.snapshot.paramMap.get('token');
    if (!token) {
      this.toastr.error(this.translate.instant('INVALID_RESET_TOKEN'));
      return;
    }

    this.pending = true;
    this.authService
      .recoverPassword({ code: token, password, passwordConfirmation: confirmPassword })
      .pipe(
        finalize(() => (this.pending = false)),
        take(1)
      )
      .subscribe({});
  }
}
